import React from 'react'

interface UnassignDeviceConfirmationModalProps {
  isOpen: boolean
  title: string
  description: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
}

export default function UnassignDeviceConfirmationModal({
  isOpen,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}: UnassignDeviceConfirmationModalProps) {
  if (!isOpen) return null

  return (
    <div
      className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'
      role='dialog'
      aria-modal='true'
    >
      <div className='bg-white rounded-lg shadow-lg max-w-sm w-full p-6'>
        <h2 className='text-xl font-semibold mb-4'>{title}</h2>
        <p className='mb-6 text-gray-700'>{description}</p>
        <div className='flex justify-end space-x-3'>
          <button
            onClick={onCancel}
            className='px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800'
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className='px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded'
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
